module.exports = __webpack_public_path__ + "img/popup-btn-owner.3bd5491.png";